import { render, staticRenderFns } from "./FullSwapModalContent.vue?vue&type=template&id=351ee3a7&scoped=true"
import script from "./FullSwapModalContent.vue?vue&type=script&lang=js"
export * from "./FullSwapModalContent.vue?vue&type=script&lang=js"
import style0 from "./FullSwapModalContent.vue?vue&type=style&index=0&id=351ee3a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ee3a7",
  null
  
)

export default component.exports